export default __webpack_public_path__ + "static/media/event1.1513904e.jpg";